import { render, staticRenderFns } from "./MyAddresses.vue?vue&type=template&id=07fbf17c&scoped=true&"
import script from "./MyAddresses.vue?vue&type=script&lang=js&"
export * from "./MyAddresses.vue?vue&type=script&lang=js&"
import style0 from "./MyAddresses.vue?vue&type=style&index=0&id=07fbf17c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fbf17c",
  null
  
)

export default component.exports